import { render, staticRenderFns } from "./order-details-page.vue?vue&type=template&id=b1f3a67a&scoped=true"
import script from "./order-details-page.vue?vue&type=script&lang=js"
export * from "./order-details-page.vue?vue&type=script&lang=js"
import style0 from "./order-details-page.vue?vue&type=style&index=0&id=b1f3a67a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f3a67a",
  null
  
)

export default component.exports